import Cache from 'root/cache';
import UI from 'root/ui';
import Modals from 'root/modals';
import Form from 'root/module/form';
import View from 'view/base';

export default View.extend({
    events: {
        'click .sso-view'     : 'onToggleKey',
        'click .sso-login'    : 'onToggleSsoLogin',
        'input textarea'      : 'onMessageChange',
        'submit .translation' : 'onSubmitTranslation'
    },

    dom_handlers: {
        onToggleKey: function() {
            var input = this.$el.find('input[name="sso_key"]');

            if (input.attr('type') === 'text') {
                this.$el.find('input[name="sso_key"]')
                    .attr('type', 'password')
                    .val(this.model.get('sso_key'));

                this.$el.find('.sso-view').html('<i class="fa-solid fa-eye"></i>');
            } else {
                this.$el.find('input[name="sso_key"]')
                    .attr('type', 'text')
                    .val(this.model.get('sso_key'));

                this.$el.find('.sso-view').html('<i class="fa-solid fa-eye-slash"></i>');
            }
        },

        onToggleSsoLogin: function() {
            if (!Cache.account.hasFeature('private_portal')) {
                Modals.unlockFeature();
                return;
            }

            var sso_login = !this.model.get('sso_login');

            if (sso_login) {
                this.$el.find('.sso-login').addClass('switch-on').removeClass('switch-off');
            } else {
                this.$el.find('.sso-login').addClass('switch-off').removeClass('switch-on');
            }

            this.$el.find('form.translation').toggle(sso_login);

            Cache.app.request({
                action: 'portal/update',
                data: {
                    portal_id : this.model.id,
                    sso_login : sso_login
                },
                success: () => {
                    this.model.set('sso_login', sso_login);
                    UI.success('SSO settings updated');
                }
            });
        },

        onMessageChange: function() {
            var custom_message = Form.getData(this.$el.find('form.translation')).private_access;
            var is_changed = false;

            if (this.model.get('translation')) {
                if (custom_message !== this.model.get('translation').private_access) {
                    is_changed = true;
                }
            } else {
                if (custom_message) {
                    is_changed = true;
                }
            }

            this.$el.find('form.translation button:submit').prop('disabled', !is_changed);
        },

        onSubmitTranslation: function() {
            var form_data = Form.getData(this.$el.find('form.translation'));

            this.$el.find('form.translation button:submit').addClass('loading').prop('disabled', true);

            Cache.app.request({
                action: 'portal/updateTranslation',
                data: {
                    portal_id : this.model.id,
                    private_access: form_data.private_access
                },
                success: (response) => {
                    this.model.set('translation', response);
                    UI.success('Custom message updated');
                },
                complete: () => {
                    this.$el.find('form.translation button:submit').removeClass('loading');
                }
            });
        }
    },

    render: function() {
        var content =
        '<div class="box box-nopadding">' +
            '<div class="padding-32">' +
                '<div class="text-info text-medium padding-right-24">' +
                    'Use SSO to automatically log your app users into the ideas portal. For implementation details, please check this <a class="text-info" href="https://support.userback.io/en/articles/6102051-getting-started-with-your-feedback-portal-and-configuring-portal-settings" target="help" rel="noopener">help article</a>.' +
                '</div>' +
                '<div class="divider-24"></div>' +
                '<div class="grid-4-8 grid-none-mobile">' +
                    '<div>' +
                        '<h3 class="margin-top-8">Private Key</h3>' +
                    '</div>' +
                    '<div>' +
                        '<div class="copy-input-medium">' +
                            '<div><input type="password" name="sso_key" value=".........................." class="medium" readonly></div>' +
                            '<button class="sso-view medium round text"><i class="fa-solid fa-eye"></i></button>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
            '</div>' +

            '<hr class="xsmall">' +

            '<div class="padding-32 flex-between-top">' +
                '<div>' +
                    '<h3>Enforce SSO</h3>' +
                    '<div class="text-info text-medium">Only logged in users via SSO can access the ideas portal.</div>' +
                    '<form class="translation form-fluid position-relative margin-top-24">' +
                        '<div>Add a custom message</div>' +
                        '<div class="text-info text-small margin-top-4">The message is displayed for anonymous users when when not logged in via SSO.</div>' +
                        '<textarea name="private_access" class="solid compact margin-top-12" maxlength="1000" rows="6" placeholder="Private\nOnly logged in users can access the ideas portal."></textarea>' +
                        '<div class="text-inline-help"><i class="info fas fa-question-circle"></i><div>You can use markdown syntax to add links.<br><br>For example:<br><span class="font-weight-medium">[Visit our website](https://www.example.com)</span><br><span class="font-weight-medium">[Contact us](mailto:help@example.com)</span></div></div>' +
                        '<div class="divider-4"></div>' +
                        '<button class="primary small float-right" disabled>Save</button>' +
                    '</form>' +
                '</div>' +
                '<div>' +
                    (Cache.account.hasFeature('private_portal') ? '' :
                    '<span class="toggle-lock"><i class="fas fa-lock-alt"></i></span>') +
                    '<button type="button" class="sso-login small ' + (this.model.get('sso_login') ? 'switch-on' : 'switch-off') + (Cache.account.hasFeature('private_portal') ? '' : ' disabled') + '"></button>' +
                '</div>' +
            '</div>' +
        '</div>';

        this.$el.html(content);

        if (!this.model.get('sso_login')) {
            this.$el.find('form.translation').hide();
        }

        if (this.model.get('translation')) {
            Form.setData(this.$el.find('form.translation'), this.model.get('translation'));
        }

        return this;
    }
});